/* eslint-disable react/prop-types */
import { Link } from 'react-router-dom';
import './productdisplay.scss';
const API_URL = import.meta.env.VITE_API_URL;

const ProductDisplay = ({ products, currentPage, setCurrentPage }) => {
  if (!Array.isArray(products)) {
    console.error('Expected products to be an array, but got:', products);
    return <p>Unexpected data format.</p>;
  }

  const itemsPerPage = 64;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = products.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const totalPages = Math.ceil(products.length / itemsPerPage);

  return (
    <div className="product-display-section">
      <div className="product-grid">
        {currentItems.map((product) => (
          <div key={product.id} className="product">
            <Link to={`/product/${product.id}`}>
            <img
                src={`${API_URL}/products/compressed${product.mainImagePath}`}
                alt={product.name}
                loading="lazy"
              />
              <h4>{product.name}</h4>
              <p>Kategorija: {product.subcategory}</p>
             
              <p> Cena: {product.price}
              {/\d/.test(product.price) && ' RSD'}</p>
            </Link>
          </div>
        ))}
      </div>
      <div className="pagination">
        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index}
            onClick={() => paginate(index + 1)}
            className={`pagination-button ${index + 1 === currentPage ? 'active' : ''}`}
          >
            {index + 1}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProductDisplay;
